export const calculatePreExtrasTotal = (bookingData = {}) => {
  const studioPrice = Number(bookingData?.totalStudioPrice) || 0;
  const feesTotal = (bookingData?.appliedFees || []).reduce(
    (sum, fee) => sum + (Number(fee?.amount) || 0),
    0
  );

  return Math.round((studioPrice + feesTotal) * 100) / 100;
};

export default calculatePreExtrasTotal;
